"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Mail = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M5.217 6.5H18.89l-6.837 6.837L5.217 6.5zM3.5 6.905l8.554 8.553L20.5 7.012V17.5h-17V6.905zM21.008 5H2.992C2.456 5 2 5.451 2 6.007v11.986A.999.999 0 0 0 2.992 19h18.016c.537 0 .992-.451.992-1.007V6.007A.999.999 0 0 0 21.008 5z", children: " " })
] });
var Mail_default = Mail;
export {
  Mail_default as default
};
